import { createAsyncThunk } from '@reduxjs/toolkit';
import moment from 'moment';
import { RECORDS_CREATE } from 'scenes/Permissions/constants/permissions';
import { selectIsRequiredPermission } from 'scenes/Permissions/store/selectors/personalPermissionsSelectors';
import { loadAssignmentsForProject } from 'store/assignments/thunks/loadAssignmentsForProject';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { selectProjectResources } from 'store/resources/selectors/resources.selectors';
import { loadResourcesAndResourceEmployersOfProject } from 'store/resources/thunks/loadResourcesAndResourceEmployersOfProject';
import {
  selectLoggedInUserId,
  selectUserActiveEmployerId,
} from 'store/user/selectors.js/user.selectors';

export const openCreateRecordDialog = createAsyncThunk(
  'demo/openCreateRecordDialog',
  async (projectId, { getState, dispatch }) => {
    const selectedProjectId = projectId
      ? projectId
      : selectSelectedProjectId(getState());

    dispatch(loadResourcesAndResourceEmployersOfProject(selectedProjectId));
    dispatch(loadAssignmentsForProject(selectedProjectId));

    const isPermissionToCreateRecords = selectIsRequiredPermission(
      getState(),
      RECORDS_CREATE
    );

    const projectResources = selectProjectResources(
      getState(),
      selectedProjectId
    );

    const loggedInUserId = selectLoggedInUserId(getState());

    const selectedEmployerId = selectUserActiveEmployerId(getState());

    const initialResourceId = returnInitialResourceIdFromLoggedInUser(
      projectResources,
      loggedInUserId,
      selectedEmployerId
    );

    const recordInitialData = {
      project: selectedProjectId,
      resource: initialResourceId,
      clockInAt: moment().toISOString(),
      clockOutAt: moment().toISOString(),
      billedClockInAt: moment().toISOString(),
      billedClockOutAt: moment().toISOString(),
      status: 'OUT',
      type: isPermissionToCreateRecords ? 'WORK' : 'ABSENCE',
      ...(!isPermissionToCreateRecords ? { subType: 'SICK_LEAVE' } : {}),
    };

    return recordInitialData;
  }
);

const returnInitialResourceIdFromLoggedInUser = (
  projectResources,
  loggedInUserId,
  selectedEmployer
) => {
  const loggedInUserResourceFromActiveEmployer = projectResources.find(
    (resource) =>
      resource.user === loggedInUserId &&
      resource.employer &&
      resource.employer === selectedEmployer
  );

  const loggedInUsersResourceWithAnyEmployer = projectResources.find(
    (resource) => resource.user === loggedInUserId && resource.employer
  );

  if (loggedInUserResourceFromActiveEmployer) {
    return loggedInUserResourceFromActiveEmployer.id;
  } else if (loggedInUsersResourceWithAnyEmployer) {
    return loggedInUsersResourceWithAnyEmployer.id;
  } else {
    return undefined;
  }
};
